import React from "react"
import { useHistory } from "react-router-dom";
import _ from "lodash"
import statesData from "../../data/states.json"

import Select from 'react-select'

import "../../assets/styles/nav/nav-states.scss"

export default function StatesNav() {
  const history = useHistory();

  const handleOnChange = ({ value }) => {
    if (value === "default") return null
    history.push(`/state/${_.toLower(value)}`)
  }

  const options = _.reduce(statesData, (acc, state) => {
    if (_.isEmpty(state.plots)) return acc
    return [
      ...acc,
      {
        label: state.name,
        value: state.abbreviation,
      }
    ]
  }, [])

  return (
    <div style={{ width: 280, margin: "0 auto" }}>
      <Select options={options} onChange={handleOnChange} />
    </div>
  )
}
